module.exports = __webpack_public_path__ + "static/img/13023B_5_R_20200317_fit.3eeb9ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13023B_5_R_20200317_fit.png
// module id = A1Sb
// module chunks = 0